<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="TeamId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="false"
      :query-params="params"
      :get-data-func="getFuncData"

    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/team").default,
      params: {}
    };
  },
  methods: {
    getFuncData() {
      return new Promise((resolve) => {
        this.api.list({}).then((res) => {
          res.Data.forEach((item) => {
            item.TeamList = item.DetailDtos.reduce(
              (arr, subItem, index, data) => {
                if (index < data.length - 1) arr +=subItem.EmpName + ",";
                if (index == data.length - 1) arr +=subItem.EmpName;
                return arr;
              },
              ''
            );
          });
          resolve({ Data: res.Data,Count:res.Count,Code:res.Code,Msg:res.Msg});
        });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>